<script>
	import { individualCapacityTypes } from "../config";
	import ContactModel from "../models/Contact";
	import AddressModel from "../models/Address";

	import FormRow from "./FormRow.svelte";
	import FormColumn from "./FormColumn.svelte";
	import Contact from "./Contact.svelte";
	import Checkbox from "./Checkbox.svelte";
	import Select from "./Select.svelte";
	import PrimaryButton from "./buttons/PrimaryButton.svelte";

	export let contact = null;
	export let individual = null;
	export let capacity;
	export let authorisedToAct = false;
	export let disabled = null;
	export let required = null;

	let mainContactName = "Main Contact";
	$: {
		if (contact.FirstName && contact.Surname) {
			mainContactName = `${contact.FirstName} ${contact.Surname}`;
		} else if (contact.FirstName) {
			mainContactName = contact.FirstName;
		} else if (contact.Surname) {
			mainContactName = contact.Surname;
		} else {
			mainContactName = "Main Contact";
		}
	}

	const sameContactDetails = () => {
		individual.PhoneNumber = contact.PhoneNumber;
		individual.EmailAddress = contact.EmailAddress;
		Object.keys(contact.Address).forEach((key, i) => {
			individual.Address[key] = contact.Address[key];
		});
	};

	const initialise = () => {
		if (!individual) {
			individual = getIndividual();
		}
	};

	const getIndividual = () => {
		let individual = new ContactModel();
		individual.Address = new AddressModel();

		return individual;
	};

	initialise();
</script>

{#if individual}
	<FormRow>
		<FormColumn cols="6">
			<h3>Individuals Details</h3>
		</FormColumn>
		<!-- <FormColumn cols="6" class="last">
			{#if !disabled}
				<PrimaryButton small={true} on:click={() => sameContactDetails(0)}
					>Same contact details as {mainContactName}</PrimaryButton>
			{/if}
		</FormColumn> -->
	</FormRow>

	<Contact
		bind:salutation={individual.Title}
		bind:firstName={individual.FirstName}
		bind:surname={individual.Surname}
		bind:email={individual.Email}
		bind:phone={individual.Phone}
		bind:address={individual.Address}
		{disabled}
		{required}
		idPrefix="i1"></Contact>
{/if}

<FormRow>
	<FormColumn cols="6">
		<label for="capacity">Capacity</label>
		<Select
			{disabled}
			bind:value={capacity}
			id="capacity"
			optionList={individualCapacityTypes}
			textProperty="name"
			valueProperty="name"></Select>
	</FormColumn>
</FormRow>

<FormRow>
	<FormColumn>
		<Checkbox
			{disabled}
			bind:checked={authorisedToAct}
			label="I am authorised to act on behalf of the Individual"
			{required}
			id="authjh"></Checkbox>
	</FormColumn>
</FormRow>
